import { Money } from '@hivebrite/utils';

import isValueEmpty from 'hb-react/shared/utils/isValueEmpty';

export const errorMessage = __('Must be a number');

export const validateNumberFormat = (value) => {
  let error;

  if (value instanceof Money) {
    if (value.isNegative()) {
      return errorMessage;
    }

    return;
  }

  if (isValueEmpty(value)) {
    return error;
  }

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value) || Array.isArray(value)) {
    error = errorMessage;
  }

  return error;
};
